import { render, staticRenderFns } from "./ModalAsignacion.vue?vue&type=template&id=67d2c56c&"
import script from "./ModalAsignacion.vue?vue&type=script&lang=ts&"
export * from "./ModalAsignacion.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAsignacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports